module.exports = __webpack_public_path__ + "static/media/AU.6f36e89f.svg";